import React from 'react';

import {
  LegacyText,
  LegacyBox,
  Popover,
  IconButton,
  SettingsIcon,
} from '@gogame/components';
import { withForm, FormField } from '@gogame/form';

import {
  CHART_SETTINGS_TREND,
  CHART_SETTINGS_SERIES_SUM,
} from 'scenes/KPI/constants';

import { SettingsBlock, SettingsBlocksWrapper } from './SettingsBlock';

export const SettingsForm = withForm({
  enableReinitialize: true,
})(({ submitForm, dirty, seriesSumDisabled }) => {
  const handleClose = () => {
    if (dirty) {
      submitForm();
    }
  };

  return (
    <Popover
      anchor={<IconButton tooltip={'Chart settings'} icon={<SettingsIcon />} />}
      onClose={handleClose}
      PaperProps={{
        style: {
          elevation: 4,
          width: '180px',
        },
      }}
    >
      <SettingsBlocksWrapper data-cy={'chartSettings'}>
        <SettingsBlock style={{ minWidth: '160px' }}>
          <LegacyBox style={{ padding: '0 8px 8px' }}>
            <LegacyText variant={'caption'} intensity={200}>
              Tools
            </LegacyText>
          </LegacyBox>
          <FormField.Checkbox
            name={CHART_SETTINGS_TREND}
            label={'Trend line'}
            padding={'0'}
          />
          <FormField.Checkbox
            name={CHART_SETTINGS_SERIES_SUM}
            label={'Series sum'}
            padding={'0'}
            disabled={seriesSumDisabled}
          />
        </SettingsBlock>
      </SettingsBlocksWrapper>
    </Popover>
  );
});
